module.exports = __webpack_public_path__ + "img/events.6a65ffc3.svg";